import { LogIn } from 'lucide-react';

interface AuthPromptProps {
  message?: string;
  compact?: boolean;
}

export function AuthPrompt({ message = 'Sign in to access this feature', compact = false }: AuthPromptProps) {
  if (compact) {
    return (
      <p className="text-xs text-muted-foreground font-body flex items-center gap-1.5">
        <LogIn className="h-3.5 w-3.5 text-primary" />
        {message}
      </p>
    );
  }

  return (
    <div className="flex flex-col items-center justify-center py-16 px-6 text-center">
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-primary/10 mb-4">
        <LogIn className="h-7 w-7 text-primary" />
      </div>
      <h3 className="font-display text-lg font-semibold text-foreground mb-1">{message}</h3>
      <p className="text-sm text-muted-foreground font-body">Create an account or sign in to get started</p>
    </div>
  );
}
